import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import { GoDesktopDownload } from "react-icons/go";
import { MdDeleteForever } from "react-icons/md";
import { MdNoteAdd } from "react-icons/md";
import { MdModeEdit } from "react-icons/md";
import AddProduct from './AddProduct'
import Paper from '@material-ui/core/Paper';
import { IoIosArrowDropleft } from "react-icons/io";
import {Link} from 'react-router-dom'; 
import AdminProduct from'./AdminProduct';
import TableEditablePage from './EditRemove';
import Button from '@material-ui/core/Button';
import { MdEdit } from "react-icons/md";
import { MdAddShoppingCart } from "react-icons/md";

const drawerWidth = 240;


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));

export default function PersistentDrawerLeft(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  function handleDrawerOpen() {
    setOpen(true);
  }

  function handleDrawerClose() {
    setOpen(false);
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
          <img  src="https://www.saylaniwelfare.com/public_html/images/saylani/Saylani-logo.png"  width="200px"/>
          <Link to="/"><IoIosArrowDropleft />Back</Link></Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Divider />
        <List>
          {/* {['Dashboard', 'Delete', 'Edit', 'Add Product'].map((text, index) => (
            <ListItem button key={text}>
              <ListItemIcon>{index % 2 === 0 ? <GoDesktopDownload /> : <MdDeleteForever />}</ListItemIcon>
            <ListItemText primary={text} />
            onClick={()=>props.history.push('/Dashboard')}
            </ListItem>
          ))} */}
         <p>
          <Link to="/dashboard">
          <Button size="large" style={{ color: "#fff", backgroundColor: "#3f50b5",padding:"0px",width:'100%' }}>
             Dashboard<GoDesktopDownload />
                    </Button>
            </Link></p>
           <p>
            <Link to="/editremove">
            <Button size="large" style={{ color: "#fff", backgroundColor: "#3f50b5",padding:"0px",width:'100%' }}>
          Edit Product<MdEdit />   
                    </Button>
            </Link></p>
            <p>
          <Link to="/addproduct">
          <Button size="large" style={{ color: "#fff", backgroundColor: "#3f50b5",padding:"0px",width:'100%' }}>
       Add Products<MdNoteAdd/>
                    </Button>
            </Link></p>
            <p>
            <p>
            <Link to="/editremove">
            <Button size="large" style={{ color: "#fff", backgroundColor: "#3f50b5",padding:"0px",width:'100%' }}>
           Delete Product<MdDeleteForever />
                    </Button>
            </Link></p>
          <Link to="/order">
          <Button size="large" style={{ color: "#fff", backgroundColor: "#3f50b5",padding:"0px",width:'100%' }}>
      Order<MdAddShoppingCart/>
                    </Button>
            </Link></p>
        </List>
        <Divider />
        {/* <List>
          {['All mail', 'Trash', 'Spam'].map((text, index) => (
            <ListItem button key={text}>
              <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List> */}
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <div className={classes.drawerHeader} />

        <Typography paragraph>
          <Paper >


          {/* <AddProduct /> */}

          </Paper>
          {/* <PanelPage />
          <AdminProduct /> */}
          {/* <TableEditablePage / */}
        </Typography>
      </main>
    </div>
  );
}